<template>
  <div
    v-show="!hideWidget"
    v-if="!showDialog"
    :class="buttonPosition === 'left' ? 'widget-left' : 'widget-right'"
    :style="`${
      hideCard ? (buttonPosition === 'left' ? 'left: 0px;' : 'right: 0px;') : ''
    } bottom: calc(40px + ${verticalPosition}px)`"
  >
    <v-card
      v-if="!hideCard"
      class="card-style"
      :color="buttonColor"
      width="250px"
    >
      <v-img
        v-if="eventImage"
        :src="eventImage"
        style="cursor: pointer"
        @click="$emit('toogleDialog')"
      >
        <v-row justify="end" no-gutters>
          <div class="action-box-right" @click="hideCard = true">
            <v-icon size="20" color="black">mdi-close</v-icon>
          </div>
        </v-row>
      </v-img>
      <v-btn
        class="button-style"
        id="open-blueticket-checkout-button"
        :color="buttonColor"
        width="100%"
        dark
        depressed
        height="44"
        @click="$emit('toogleDialog')"
        ><span class="text-button-style">{{ buttonText }}</span>
      </v-btn>
    </v-card>

    <div
      v-else
      :class="
        buttonPosition === 'left' ? 'simple-button-left' : 'simple-button-right'
      "
      :style="`background-color: ${buttonColor}`"
      @click="handleHideCard"
    >
      <span class="text-button-style">{{ buttonText }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "showDialog",
    "buttonText",
    "buttonColor",
    "buttonPosition",
    "eventImage",
    "verticalPosition",
    "hideWidget",
  ],

  data() {
    return {
      hideCard: false,
    };
  },

  mounted() {
    if (!this.eventImage) this.hideCard = true;
  },

  methods: {
    handleHideCard() {
      if (!this.eventImage) this.$emit("toogleDialog");
      else this.hideCard = false;
    },
  },
};
</script>

<style scoped>
.widget-right {
  position: fixed;
  right: 40px;
  z-index: 9999;
}

.widget-left {
  position: fixed;
  left: 40px;
  z-index: 9999;
}

.text-button-style {
  font-weight: 600;
  font-size: 16px;
  color: white;
}

.button-style {
  border-top-left-radius: 0px !important;
  border-top-right-radius: 0px !important;
  border-radius: 20px !important;
}

.action-box-right {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-bottom-left-radius: 10px;
  height: 30px;
  width: 30px;
  cursor: pointer;
}

.card-style {
  border-radius: 20px;
}

.simple-button-right {
  padding: 8px 15px;
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  cursor: pointer;
}

.simple-button-left {
  padding: 8px 15px;
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  cursor: pointer;
}
</style>
